import { useEffect } from "react";

export const useOnMount = (effect) => {
  useEffect(() => {
    effect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
